import { jsx as r } from "react/jsx-runtime";
import "react";
import { ImageCard as e } from "../../../ImageCard/ImageCard.js";
function o(a) {
  return /* @__PURE__ */ r("div", { className: "image-card-slide", children: /* @__PURE__ */ r(e, { ...a }) });
}
export {
  o as ImageCardSlide,
  o as default
};
